module.exports = __webpack_public_path__ + "me.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/me.svg
// module id = 937
// module chunks = 0